import { Pencil } from "lucide-react";

/** 0.5rem. 이보다 위로 나가면 아래로 뒤집는다. */
const FLIP_MARGIN_PX = 8;

export type PixelArtEditButtonProps = {
  /** 앵커로 쓸 장면 좌표(회전을 반영한 바깥 상자의 오른쪽 변). */
  anchor: { x: number; minY: number; maxY: number };
  /** 장면 좌표를 화면 픽셀로 바꾼다(`screenX = (sceneX + scrollX) * zoom`). */
  toScreen(x: number, y: number): { x: number; y: number };
  onEdit(): void;
};

/** 선택한 픽셀 아트 위(오른쪽 위)에 뜨는 "고치기" 버튼. 화면 크기는 줌과 무관하다. */
export const PixelArtEditButton = ({
  anchor,
  toScreen,
  onEdit,
}: PixelArtEditButtonProps) => {
  const above = toScreen(anchor.x, anchor.minY);
  // 화면 위로 잘리면 요소 아래쪽으로 뒤집는다.
  const flip = above.y - 12 < FLIP_MARGIN_PX;
  const point = flip ? toScreen(anchor.x, anchor.maxY) : above;
  return (
    <div
      className="canvaschool-pixel-edit canvaschool-no-print"
      style={{
        left: `${point.x}px`,
        top: `${flip ? point.y + 12 : point.y - 12}px`,
        transform: flip ? "translate(-100%, 0)" : "translate(-100%, -100%)",
      }}
    >
      <button
        type="button"
        className="canvaschool-pixel-edit-button"
        aria-label="픽셀 아트 고치기"
        data-testid="pixel-art-edit"
        onClick={onEdit}
      >
        <Pencil size={14} aria-hidden="true" />
        <span aria-hidden="true">고치기</span>
      </button>
    </div>
  );
};
